import React, { useEffect, useState } from 'react'
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './cruise.css'
import dayjs from 'dayjs'
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import Carousel from 'react-multi-carousel'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Link, useNavigate } from 'react-router-dom'
import { airports, city } from '../../api/airport'
import { FormControl } from '@mui/material'
import { flightBooking } from '../../api/flight'
import { ToastContainer, toast } from 'react-toastify'
import { cruiseBooking, cruiseCity } from '../../api/cruise'
import { packageCity, packageGet } from '../../api/package'
// -------------------------------------------------


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const destination = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
    slidesToSlide: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
}

const Cruise = () => {
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openB = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [value, setValue] = React.useState(0);
  const notify = (message) => toast(message)
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      setFlighDetails({
        from: "",
        to: "",
        departureDate: "",
        returnDate: "",
        passengerCount: 0,
        cruiseType: "",
        type: 'One Way'
      })
    } else if (newValue === 1) {
      setFlighDetails({
        from: "",
        to: "",
        departureDate: "",
        returnDate: "",
        passengerCount: 0,


        cruiseType: "",
        type: 'Round Trip'
      })
    }
  };


  const [flightDetails, setFlighDetails] = useState({
    from: "",
    to: "",
    departureDate: "",
    returnDate: "",
    passengerCount: 0,

    type: "One Way" || "",
    cruiseType: "",
  })


  const [count, setCount] = useState(0)

  const [cities, setCities] = useState([])
  useEffect(() => {
    if (count) {
      setFlighDetails({
        ...flightDetails,
        passengerCount: count
      })
    }
  }, [count])
  // const getCities = async () => {
  //   const resp = await city()
  //   setCities(resp.data)
  // }

  // useEffect(() => {
  //   getCities()
  // }, [])



  function checkEmptyKeys(obj) {
    for (const key in obj) {
      if (obj[key] === "" || obj[key] === 0) {
        return true;
      }
    }
    return false;
  }

  const token = localStorage.getItem('token')
  console.log(checkEmptyKeys(flightDetails))
  const submit = async () => {
    if (token) {
      if (flightDetails.type === 'One Way') {
        delete flightDetails.returnDate
        if (flightDetails.departureDate === '') {
          notify('Departure Date is required')
        }
        else if (flightDetails.from === '') {
          notify('From is required')
        } else if (flightDetails.to === '') {
          notify('To is required')
        } else if (flightDetails.passengerCount === 0) {
          notify('Passenger Count is required')
        } else if (flightDetails.cruiseType === '') {
          notify('Train Type is required')
        } else if (flightDetails.type === '') {
          notify('Type is required')
        } else {
          try {
            const resp = await cruiseBooking(flightDetails)
            if (resp.code === 201) {
              notify(resp.message)
              setCount(0)
              setFlighDetails({
                from: "",
                to: "",
                departureDate: "",
                returnDate: "",
                passengerCount: 0,

                type: "One Way" || "",
                cruiseType: "",
              })
            } else {
              notify(resp.message)
              setCount(0)

              setFlighDetails({
                from: "",
                to: "",
                departureDate: "",
                returnDate: "",
                passengerCount: 0,

                type: "One Way" || "",
                cruiseType: "",
              })
            }
          } catch (error) {
            notify(error.message)
            setCount(0)

            setFlighDetails({
              from: "",
              to: "",
              departureDate: "",
              returnDate: "",
              passengerCount: 0,

              type: "One Way" || "",
              cruiseType: "",
            })
          }


        }
      } else {
        if (flightDetails.departureDate === '') {
          notify('Departure Date is required')
        } else if (flightDetails.returnDate === '') {
          notify('Return Date is required')
        }
        else if (flightDetails.from === '') {
          notify('From is required')
        } else if (flightDetails.to === '') {
          notify('To is required')
        } else if (flightDetails.passengerCount === 0) {
          notify('Passenger Count is required')
        } else if (flightDetails.cruiseType === '') {
          notify('Train Type is required')
        } else if (flightDetails.type === '') {
          notify('Type is required')
        } else {

          try {
            const resp = await cruiseBooking(flightDetails)
            if (resp.code === 201) {
              notify(resp.message)
              setCount(0)

              setFlighDetails({
                from: "",
                to: "",
                departureDate: "",
                returnDate: "",
                passengerCount: 0,

                type: "One Way" || "",
                cruiseType: "",
              })
            } else {
              notify(resp.message)
              setCount(0)

              setFlighDetails({
                from: "",
                to: "",
                departureDate: "",
                returnDate: "",
                passengerCount: 0,

                type: "One Way" || "",
                cruiseType: "",
              })
            }
          } catch (error) {
            notify(error.message)
            setCount(0)

            setFlighDetails({
              from: "",
              to: "",
              departureDate: "",
              returnDate: "",
              passengerCount: 0,

              type: "One Way" || "",
              cruiseType: "",
            })
          }


        }
      }
    } else {
      notify('Please Login for booking')
    }


  }

  useEffect(() => {
    if (value) {

      setCount(0)
    }
  }, [value])

  const tomorrow = dayjs()

  const [cruiseCities, setCruiseCities] = useState([])

  const citiesGet = async () => {
    const resp = await cruiseCity()
    setCruiseCities(resp.data)

  }

  useEffect(() => {
    citiesGet()
  }, [])
  const City = cruiseCities?.map((items) => ({ label: items?.name, value: items?.name }))
  const toCity = cruiseCities?.filter((items) => {
    return items?.name !== flightDetails?.from
  })
  const newToCity = toCity && toCity?.map((items) => ({ label: items?.name, value: items?.name }))

  const [tourDetail, setTourDetail] = useState({
    city: '',
    type: ''
  })

  const [tourData, setTourData] = useState([])
  const [tourInternationalData, setTourInternationalData] = useState([])
  const getPackages = async () => {
    if (tourDetail.type === '') {
      alert('Please fill type')
    } else if (tourDetail.city === '') {
      alert('Please fill City')
    } else {
      const resp = await packageGet(tourDetail)
      const filterInterNational = resp.data?.filter((item) => {
        return item?.packageMode === 'International'
      })
      const national = resp.data?.filter((item) => {
        return item?.packageMode === 'National'
      })
      setTourInternationalData(filterInterNational)
      setTourData(national)
    }
  }


  const getPackage = async () => {
    const resp = await packageGet()
    const filterInterNational = resp.data?.filter((item) => {
      return item?.packageMode === 'International'
    })
    const national = resp.data?.filter((item) => {
      return item?.packageMode === 'National'
    })
    setTourInternationalData(filterInterNational)
    setTourData(national)
  }

  useEffect(() => {
    getPackage()
  }, [])

  return (
    <>
      <Header />
      <section className=''>
        <div className='container'>
          <div className="mainBannerSectionCruise">
            <div className="row">
              <div className="col-md-11 mx-auto text-center">
                <h1 className="text-dark display-3 pt-sm-5 my-5">Cruise Travel</h1>
              </div>
            </div>
            <Box
              sx={{
                width: '100%',
                backgroundColor: '#fff',
                borderRadius: '10px',
              }}>
              <Box
                className="tabSection"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '20px 25px 0px 25px',
                }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                  <Tab label="One Way" {...a11yProps(0)} />
                  <Tab label="Round Trip" {...a11yProps(1)} />
                </Tabs>
                <div className='selectSection'>

                  <Autocomplete
                    className='w-1'
                    sx={{ width: '45%', mx: 2 }}
                    size='small'
                    disablePortal
                    id="combo-box-demo"
                    value={flightDetails.cruiseType}
                    getOptionLabel={(option) => {
                      if (option.label) {
                        return option.label
                      } else if (typeof option === 'string') {
                        return option
                      } else {
                        return ""
                      }
                    }
                    }
                    isOptionEqualToValue={(option, value) => {
                      if (option.value && value.value) { return option.value === value.value } else {
                        return false
                      }
                    }}
                    options={flightTypes}
                    onChange={(e, newValue) => {
                      if (newValue !== null) {
                        setFlighDetails({
                          ...flightDetails,
                          cruiseType: newValue.value
                        })
                      } else {
                        return;
                      }

                    }}
                    renderInput={(params) => <TextField {...params} label="Select Cruise Type" />}
                  />

                  {/* <TextField className='mar' size='small' value={flightDetails.passengerCount} type='number' placeholder='Passenger Count' label='Passenger Count' onChange={(e) => {
                    setFlighDetails({
                      ...flightDetails,
                      passengerCount: e.target.value
                    })
                  }} /> */}
                  <div className='guestBox'>
                    <Button
                      id="basic-button"
                      aria-controls={openB ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={openB ? 'true' : undefined}
                      onClick={handleClick}
                      className='guestBtn'
                    >
                      {flightDetails.passengerCount > 0 ? `Passenger Count ${flightDetails.passengerCount}` : 'Passenger Count'} {' '}

                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={openB}
                      onClose={handleClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >
                      <MenuItem className='muiB'>
                        <ul class="dropdown-menu guest-selector-dropdown show" style={{ position: 'absolute', inset: '0px auto auto 0px', margin: '0px', }} data-popper-placement="bottom-start">
                          <li class="d-flex justify-content-between">
                            <div>
                              <h6 class="mb-0">Passenger</h6>

                            </div>
                            <div class="hstack gap-1 align-items-center">
                              <button

                                onClick={() => {
                                  if (count > 0) {
                                    setCount(count - 1)
                                  } else {
                                    setFlighDetails({
                                      ...flightDetails,
                                      passengerCount: 0

                                    })
                                  }
                                }}
                                class="btn btn-md btn-link adult-remove p-0 mb-0" type="button">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                </svg>
                              </button>
                              <h6 class="guest-selector-count mb-0 child">{count}</h6>
                              <button
                                onClick={() => {

                                  setCount(count + 1)


                                }}
                                class="btn btn-md btn-link adult-add p-0 mb-0" type="button">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                </svg>
                              </button>
                            </div>
                          </li>
                        </ul>
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
              </Box>
              <CustomTabPanel value={value} index={0}>
                <div className='row'>
                  <div className='col-md-6 col-lg-4'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-location-dot"></i> From</label>
                      <Autocomplete
                        size='small'
                        sx={{ mt: 1 }}
                        disablePortal
                        id="combo-box-demo"
                        options={City}
                        getOptionLabel={(option) => {
                          if (option.label) {
                            return option.label
                          } else if (typeof option === 'string') {
                            return option
                          } else {
                            return ""
                          }
                        }
                        }
                        isOptionEqualToValue={(option, value) => {
                          if (option.value && value.value) { return option.value === value.value } else {
                            return false
                          }
                        }}
                        value={flightDetails.from}
                        onChange={(e, newValue) => {
                          if (newValue !== null) {
                            setFlighDetails({
                              ...flightDetails,
                              from: newValue.value
                            })
                          } else {
                            return;
                          }

                        }}
                        renderInput={(params) => <TextField {...params} label="Select Location" />}
                      />
                    </div>
                  </div>
                  <div className='col-md-6 col-lg-4'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-location-arrow"></i> To</label>
                      <Autocomplete
                        size='small'
                        sx={{ mt: 1 }}
                        disablePortal
                        id="combo-box-demo"
                        getOptionLabel={(option) => {
                          if (option.label) {
                            return option.label
                          } else if (typeof option === 'string') {
                            return option
                          } else {
                            return ""
                          }
                        }
                        }
                        isOptionEqualToValue={(option, value) => {
                          if (option.value && value.value) { return option.value === value.value } else {
                            return false
                          }
                        }}
                        options={newToCity}
                        value={flightDetails.to}
                        onChange={(e, newValue) => {
                          if (newValue !== null) {
                            setFlighDetails({
                              ...flightDetails,
                              to: newValue.value
                            })
                          } else {
                            return;
                          }

                        }}
                        renderInput={(params) => <TextField {...params} label="Select Location" />}
                      />
                    </div>
                  </div>
                  <div className='col-md-6 col-lg-4 dateCol'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3 daeSection'>
                      <label className="mb-1"><i className="fa-solid fa-calendar"></i> Departure Date</label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker
                            label="Select Date"
                            minDate={tomorrow}

                            slotProps={{ textField: { size: 'small' } }}
                            value={flightDetails.departureDate}
                            onChange={(newValue) => {
                              const date = new Date(newValue['$d']);



                              setFlighDetails({
                                ...flightDetails,
                                departureDate: date
                              })


                            }}

                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="col-12 text-end">
                    <button
                      onClick={submit}
                      className="btn btn-primary mb-n4" >
                      Book Now <i className="fa-solid fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <div className='row'>
                  <div className='col-md-6 col-lg-3'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-location-dot"></i> From</label>
                      <Autocomplete
                        size='small'
                        sx={{ mt: 1 }}
                        disablePortal
                        id="combo-box-demo"
                        getOptionLabel={(option) => {
                          if (option.label) {
                            return option.label
                          } else if (typeof option === 'string') {
                            return option
                          } else {
                            return ""
                          }
                        }
                        }
                        isOptionEqualToValue={(option, value) => {
                          if (option.value && value.value) { return option.value === value.value } else {
                            return false
                          }
                        }}
                        options={City}
                        value={flightDetails.from}
                        onChange={(e, newValue) => {
                          if (newValue !== null) {
                            setFlighDetails({
                              ...flightDetails,
                              from: newValue.value
                            })
                          } else {
                            return;
                          }

                        }}
                        renderInput={(params) => <TextField {...params} label="Select Location" />}
                      />
                    </div>
                  </div>
                  <div className='col-md-6 col-lg-3'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-location-arrow"></i> To</label>
                      <Autocomplete
                        size='small'
                        sx={{ mt: 1 }}
                        disablePortal
                        id="combo-box-demo"
                        getOptionLabel={(option) => {
                          if (option.label) {
                            return option.label
                          } else if (typeof option === 'string') {
                            return option
                          } else {
                            return ""
                          }
                        }
                        }
                        isOptionEqualToValue={(option, value) => {
                          if (option.value && value.value) { return option.value === value.value } else {
                            return false
                          }
                        }}
                        options={newToCity}
                        value={flightDetails.to}
                        onChange={(e, newValue) => {
                          if (newValue !== null) {
                            setFlighDetails({
                              ...flightDetails,
                              to: newValue.value
                            })
                          } else {
                            return;
                          }

                        }}
                        renderInput={(params) => <TextField {...params} label="Select Location" />}
                      />
                    </div>
                  </div>
                  <div className='col-md-6 col-lg-3 dateCol'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-calendar"></i> Departure Date</label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker
                            label="Select Date"
                            minDate={tomorrow}
                            slotProps={{ textField: { size: 'small' } }}
                            value={flightDetails.departureDate}
                            onChange={(newValue) => {
                              const date = new Date(newValue['$d']);



                              setFlighDetails({
                                ...flightDetails,
                                departureDate: date
                              })


                            }}

                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className='col-md-6 col-lg-3 dateCol'>
                    <div className='form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3'>
                      <label className="mb-1"><i className="fa-solid fa-calendar"></i> Return Date</label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker
                            label="Select Date"
                            minDate={dayjs(flightDetails?.departureDate)}
                            slotProps={{ textField: { size: 'small' } }}
                            value={flightDetails.returnDate}
                            onChange={(newValue) => {
                              const date = new Date(newValue['$d']);



                              setFlighDetails({
                                ...flightDetails,
                                returnDate: date
                              })


                            }}

                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="col-12 text-end">
                    <button
                      onClick={submit}
                      className="btn btn-primary mb-n4" >
                      Book Now <i className="fa-solid fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </CustomTabPanel>
            </Box>
          </div>
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-10">
              <h4 className="mb-0 title">International Packages</h4>
            </div>
            <div className="col-2 text-end">
              <Link to="/tours/International" className="btn btn-lg btn-dark mb-0">View All</Link>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              {tourInternationalData?.map((items) => (
                <div onClick={() => {
                  navigate(`/tourDetail/${items?._id}`)
                }}

                  key={items?._id} className="destination">
                  <Box className="eximg-group g-bg-4 tourIm">
                    <img className="" src={items?.images?.[0]} alt='' />
                    {/* <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6> */}
                  </Box>
                  <div className='py-2'>
                    <div className="py-2">
                      <h5 className="card-title">
                        <a href="#!">{items?.city} </a>
                      </h5>
                    </div>
                    <div className="hstack gap-2">
                      <span className="h5 mb-0 text-success">₹ {items?.price}</span>
                      <small>Starting price</small>
                    </div>
                  </div>
                </div>
              ))}
              {/* <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div> */}
            </Carousel>
          </div >
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-10">
              <h4 className="mb-0 title">Domestic Packages</h4>
            </div>
            <div className="col-2 text-end">
              <Link to="/tours/Domestic" className="btn btn-lg btn-dark mb-0">View All</Link>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              {tourData?.map((items) => (
                <div onClick={() => {
                  navigate(`/tourDetail/${items?._id}`)
                }}

                  key={items?._id} className="destination">
                  <Box className="eximg-group g-bg-4 tourIm">
                    <img className="" src={items?.images?.[0]} alt='' />
                    {/* <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6> */}
                  </Box>
                  <div className='py-2'>
                    <div className="py-2">
                      <h5 className="card-title">
                        <a href="#!">{items?.city} , India</a>
                      </h5>
                    </div>
                    <div className="hstack gap-2">
                      <span className="h5 mb-0 text-success">₹ {items?.price}</span>
                      <small>Starting price</small>
                    </div>
                  </div>
                </div>
              ))}
              {/* <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div> */}
            </Carousel>
          </div >
        </div >
      </section >

      <section className='specialOffers'>
        <div className='container'>
          <div className="bg-light rounded-3 position-relative p-4 p-sm-5">
            <div className="row align-items-center position-relative dicoverSec">
              <div className="col-lg-8">
                <div className="d-flex">
                  <h3>It's time to discover</h3>
                  <img src="images/04-DrYI6v5l.svg" className="h-40px ms-3" alt="" />
                </div>
                <p className="mb-3 mb-lg-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.  </p>
              </div>
              <div className="col-lg-4 text-lg-end"><Link to="/tour" className="btn btn-lg btn-dark mb-0">Book Now</Link></div>
            </div>
          </div>
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Top Categories</h4>
            </div>
          </div>
          <div className="row g-4 g-xl-5 topCate">
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Adventure`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/19-BYcWTs_B.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Adventure</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/SoundScape`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/13-CeWMv36_.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Sound Scape</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Desert`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/18-C_X3yjnw.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Desert</a></h5>
                    {/* <span>1587 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Pilgrims`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/19-BYcWTs_B.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Pilgrims</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/History`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/17-E7K6iGPB.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">History</a></h5>
                    {/* <span>986 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/IslandHopper`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/14-fpi-ZIwa.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">IslandHopper</a></h5>
                    {/* <span>786 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/General`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/16-D1cIRfhu.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">General</a></h5>
                    {/* <span>786 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Haunted`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/15-CGaqJfSo.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Haunted</a></h5>
                    {/* <span>568 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/14-fpi-ZIwa.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Temple</a></h5>
                    <span>256 Places</span>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/13-CeWMv36_.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Festival</a></h5>
                    <span>654 Places</span>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Worlds Luxury Cruise</h4>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              <div className="vehicles">
                <div className="card shadow text-center align-items-center h-100 p-3 border-0">
                  <div className="icon-Package bg-light rounded-circle">
                    <img src="images/cruise-cmpny1.jpg" alt="vehicleImg" />
                  </div>
                </div>
              </div>
              <div className="vehicles">
                <div className="card shadow text-center align-items-center h-100 p-3 border-0">
                  <div className="icon-Package bg-light rounded-circle">
                    <img src="images/cruise-cmpny2.jpg" alt="vehicleImg" />
                  </div>
                </div>
              </div>
              <div className="vehicles">
                <div className="card shadow text-center align-items-center h-100 p-3 border-0">
                  <div className="icon-Package bg-light rounded-circle">
                    <img src="images/cruise-cmpny3.jpg" alt="vehicleImg" />
                  </div>
                </div>
              </div>
              <div className="vehicles">
                <div className="card shadow text-center align-items-center h-100 p-3 border-0">
                  <div className="icon-Package bg-light rounded-circle">
                    <img src="images/cruise-cmpny4.jpg" alt="vehicleImg" />
                  </div>
                </div>
              </div>
              <div className="vehicles">
                <div className="card shadow text-center align-items-center h-100 p-3 border-0">
                  <div className="icon-Package bg-light rounded-circle">
                    <img src="images/cruise-cmpny5.jpg" alt="vehicleImg" />
                  </div>
                </div>
              </div>
              <div className="vehicles">
                <div className="card shadow text-center align-items-center h-100 p-3 border-0">
                  <div className="icon-Package bg-light rounded-circle">
                    <img src="images/cruise-cmpny6.jpg" alt="vehicleImg" />
                  </div>
                </div>
              </div>
            </Carousel>
          </div>
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Why Choose Us</h4>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-sm-6 col-lg-4">
              <div className="card shadow p-4 h-100 border-0">
                <div className="icon-lg bg-primary bg-opacity-10 text-primary rounded-circle mb-4">
                  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="fs-5">
                    <path d="M5.52.359A.5.5 0 0 1 6 0h4a.5.5 0 0 1 .474.658L8.694 6H12.5a.5.5 0 0 1 .395.807l-7 9a.5.5 0 0 1-.873-.454L6.823 9.5H3.5a.5.5 0 0 1-.48-.641z"></path>
                  </svg>
                </div>
                <h5>Authentic and Relaible</h5>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4">
              <div className="card shadow p-4 h-100 border-0">
                <div className="icon-lg bg-success bg-opacity-10 text-success rounded-circle mb-4">
                  <svg className="svg-inline--fa fa-leaf fa-solid fa-leaf fs-5" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="leaf" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path className="" fill="currentColor" d="M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.3 5.4c-25.9 5.9-49.9 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"></path>
                  </svg>
                </div>
                <h5>World Class Services</h5>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4">
              <div className="card shadow p-4 h-100 border-0">
                <div className="icon-lg bg-warning bg-opacity-15 text-warning rounded-circle mb-4">
                  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="fs-5">
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m6.43-5.228a7.03 7.03 0 0 1-3.658 3.658l-1.115-2.788a4 4 0 0 0 1.985-1.985zM5.228 14.43a7.03 7.03 0 0 1-3.658-3.658l2.788-1.115a4 4 0 0 0 1.985 1.985zm9.202-9.202-2.788 1.115a4 4 0 0 0-1.985-1.985l1.115-2.788a7.03 7.03 0 0 1 3.658 3.658m-8.087-.87a4 4 0 0 0-1.985 1.985L1.57 5.228A7.03 7.03 0 0 1 5.228 1.57zM8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6"></path>
                  </svg>
                </div>
                <h5>Over 10K Happy Customers</h5>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4">
              <div className="card shadow p-4 h-100 border-0">
                <div className="icon-lg bg-danger bg-opacity-10 text-danger rounded-circle mb-4">
                  <svg className="svg-inline--fa fa-car fs-5" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="car" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path className="" fill="currentColor" d="M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"></path>
                  </svg>
                </div>
                <h5>More Than 350 Destinations</h5>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4">
              <div className="card shadow p-4 h-100 border-0">
                <div className="icon-lg bg-warning bg-opacity-10 text-warning rounded-circle mb-4">
                  <svg className="svg-inline--fa fa-wifi fs-5" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="wifi" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                    <path className="" fill="currentColor" d="M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"></path>
                  </svg>
                </div>
                <h5>Top Rated Agents and Advisors</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="wmyha">
        <div class="container">
          <div class="row awesome-holiday justify-content-center">
            <div class="col-lg-3">
              <img src="./images/logo-big.png" alt="" />
            </div>
            <div class="col-lg-9 p-3">
              <span>We make</span>
              <h3>your holiday awesome </h3>
              <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.</p>
              <button className="btn btn-dark py-1 px-3 mt-3" >
                Read more
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="bg-light rounded-3 position-relative p-4 p-sm-5">
            <div className="row align-items-center position-relative dicoverSec">
              <div className="col-lg-8">
                <div className="d-flex">
                  <h3>It's time to discover</h3>
                  <img src="images/04-DrYI6v5l.svg" className="h-40px ms-3" alt="" />
                </div>
                <p className="mb-3 mb-lg-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.  </p>
              </div>
              <div className="col-lg-4 text-lg-end"><Link to="/signRegister" className="btn btn-lg btn-dark mb-0">Book Now</Link></div>
            </div>
          </div>
        </div>
      </section> */}

      <ToastContainer />
      <Footer />
    </>
  )
}

export default Cruise

const classes = [
  { label: 'Economy', value: 'Economy' },
  { label: 'Business', value: 'Business' },
  { label: 'First', value: 'First' },
  { label: 'Premium Economy', value: 'Premium Economy' },
  { label: 'Premium Business', value: 'Premium Business' },
  { label: 'Premium First', value: 'Premium First' },

];
const types = [
  { label: 'Economy', value: 'Economy' },
  { label: 'Bussiness', value: 'Bussiness' },

];
const flightTypes = [
  { label: 'Luxury', value: 'Luxury' },
  { label: 'Premium', value: 'Premium' },
  { label: 'Standard', value: 'Standard' },


];